import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import analytics from "fond/analytics";
import { SEARCH_KEY } from "fond/constants";
import { useCanIPlanner } from "fond/hooks/useCanIPlanner";
import { useNoAccountRedirect } from "fond/hooks/useNoAccountRedirect";
import { useUpdateDocTitle } from "fond/hooks/useUpdateDocTitle";
import SearchResults from "fond/projects/GlobalSearch/SearchResults";
import MainWorkspaceContent from "fond/projects/MainWorkspaceContent";
import { Navigation } from "fond/projects/Navigation";
import { useQueryParams } from "fond/utils/hooks";
import { PageContent } from "fond/widgets";
import { NavButton } from "fond/widgets/Link/NavButton";

/**
 * A top level component used for displaying project.
 */
const MainWorkspace: React.FC = () => {
  useNoAccountRedirect();
  useUpdateDocTitle("Home");

  const navigate = useNavigate();
  const searchQuery = useQueryParams(SEARCH_KEY);
  const { pathname } = useLocation();
  const { canBuy, hasSub } = useCanIPlanner();

  // workaround to redirect / to /workspace
  useEffect(() => {
    if (pathname === "/") navigate("/workspace/");
  }, [navigate, pathname]);

  /**
   * Global search results page
   */
  if (searchQuery) {
    return <SearchResults />;
  }

  return (
    <PageContent
      title="Main Workspace"
      action={
        canBuy && (
          <NavButton
            onClick={() => analytics.track("workspace.upgrade.button.clicked")}
            to={hasSub ? "/subscription/manage" : "/subscription/get-started"}
          >
            Upgrade to planner
          </NavButton>
        )
      }
      mainContent={<MainWorkspaceContent />}
      navigation={<Navigation />}
      testId="filter-workspace"
    />
  );
};

export default MainWorkspace;
